module.exports = __webpack_public_path__ + "static/img/Slice 12@2x.fe7c2c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/Slice 12@2x.png
// module id = QWkn
// module chunks = 0